

export const formatFileName = (filePath) => {
    const fileName = filePath.split('/').pop().split('\\').pop();
    const nameWithoutExtension = fileName.replace(/\.[^/.]+$/, "");
    return nameWithoutExtension
        .replace(/[_-]/g, " ")
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};

